import { notification } from 'antd'
import { getLoggedInUserInfo } from 'utils'
import apiClient from '../index'

export const uploadDocument = (data, options = {}) => {
  const { silent = false } = options
  return apiClient.post('media', data, {
    suppressErrorNotification: silent,
  })
}
export const candidateUploadDocument = (data) => apiClient.post('media/candidateDocUpload', data)
export const updateCandidateDocument = (data) => apiClient.patch('media/updateCandidateMedia', data)
export const updateDocument = (data) => apiClient.patch('media/updateMedia', data)
export const uploadAttendanceExcel = (data) => apiClient.post('attendance/markAttendance', data)
export const uploadAcknowledgementDocument = (data) => apiClient.post('acknowledgement', data)
export const reuploadAcknowledgementDocument = (id, data) =>
  apiClient.patch(`acknowledgement/reupload/${id}`, data)
export const deleteAcknowledgementDocument = (id) => apiClient.delete(`acknowledgement/${id}`)
export const uploadSignDocument = (data) => apiClient.patch('acknowledgement/uploadSignDoc', data)
export const HolidayDocument = (data) =>
  apiClient.post('holidays/addHoliday', data, {
    headers: { 'Content-Type': undefined },
    suppressErrorNotification: true,
  })
export const getAckDocStatus = ({ skip, limit }, id, filter) => {
  return apiClient.get(`acknowledgement/${id}`, {
    params: {
      skip,
      limit,
      ackStatus: filter?.ackStatus,
      text: filter?.text,
    },
  })
}
export const updateStatusForAckDoc = (id, status) => {
  return apiClient.patch(`acknowledgement/updateAckDocStatus/${id}`, { status })
}

export const getAckDoc = ({ skip, limit, ackStatus }) => {
  return apiClient.get('acknowledgement', {
    params: {
      skip,
      limit,
      ackStatus,
    },
  })
}

export const getAcknowledgementDocumentURL = async (id) => {
  try {
    return await apiClient.get(`acknowledgement/acknowledgement-document/${id}`, {
      responseType: 'arraybuffer',
    })
  } catch (error) {
    if (error?.response?.status !== 404 && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getDocument = async (mediaType, year, skip, limit, userId, searchEmployee, status) => {
  // const empCode = getLoggedInUserInfo()?.empCode
  // const userId = getLoggedInUserInfo()?.userId
  try {
    return await apiClient.get('/media', {
      params: {
        mediaType,
        year,
        skip,
        limit,
        searchEmployee,
        userId,
        status,
        // empCode,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}

export const deleteDocument = async (id) => {
  const userId = getLoggedInUserInfo()?.userId
  try {
    return await apiClient.delete('media/documentDelete', {
      params: {
        id,
        userId,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}

export const salarySlip = async (value) => {
  const empCode = getLoggedInUserInfo()?.empCode
  const userRole = getLoggedInUserInfo()?.userRole
  const { mediaType, year } = value
  try {
    return apiClient.get('media/salarySlip', {
      params: {
        empCode,
        mediaType,
        year,
        userRole,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}

// //////to fetch doc from blob///////////////////
export const getEmployeeDocumentURL = async (id) => {
  try {
    return await apiClient.get(`media/documentUrl/${id}`, {
      responseType: 'arraybuffer',
      suppressErrorNotification: true,
    })
  } catch (error) {
    // A 404 just means there's no document/image for this id (e.g. no profile
    // picture set, or a stale reference) — that's an expected state, not an
    // error worth interrupting the user with a popup for.
    if (error?.response?.status !== 404 && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

export const getEmployeeDocumentObjectUrl = async (id) => {
  const response = await getEmployeeDocumentURL(id)

  if (!response?.data) {
    return null
  }

  const contentType = response?.headers?.['content-type'] || 'application/octet-stream'
  const blob = new Blob([response.data], { type: contentType })

  return URL.createObjectURL(blob)
}

export const getCompanyProfileLogo = async () => {
  try {
    return await apiClient.get('media/companyProfile', { suppressErrorNotification: true })
  } catch (error) {
    if (error?.response?.status !== 404 && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || 'Something went wrong',
      })
    }
  }
  return null
}

// /////////////to fetch candidate doc from blob/////////////////
export const getCandidateDocumentURL = async (id) => {
  if (!id || id === 'undefined' || id === 'null') {
    return null
  }

  try {
    return await apiClient.get(`media/candidate/documentUrl/${id}`, {
      responseType: 'arraybuffer',
      suppressErrorNotification: true,
    })
  } catch (error) {
    if (error?.response?.status !== 404 && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}

// /////////////to fetch reimbursement doc from blob/////////////////
export const getReimbursementDocumentURL = async (id) => {
  try {
    return await apiClient.get(`reimbursementDoc/fetch-from-blob/${id}`, {
      responseType: 'arraybuffer',
      suppressErrorNotification: true,
    })
  } catch (error) {
    if (error?.response?.status !== 404 && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
// //////to fetch expenses doc from blob///////////////////
export const getExpensesDocumentURL = async (id) => {
  try {
    return await apiClient.get(`expensesDoc/documentUrl/${id}`, {
      responseType: 'arraybuffer',
      suppressErrorNotification: true,
    })
  } catch (error) {
    if (error?.response?.status !== 404 && error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
  }
  return null
}
